import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewLeavePage () {
  const location = useLocation()
  const { t } = useTranslation()
  const leave = location?.state?.leave || null

  const columns = [
    {
      header: t('name'),
      body: row => `${row.employee?.first_name || ''} ${row.employee?.last_name || ''}`
    },
    { field: 'start_date', header: t('start_date') },
    { field: 'end_date', header: t('end_date') },
    { field: 'leave_type', header: t('leave_type') },
    { field: 'status', header: t('status') },
    { field: 'description', header: t('description') }
  ]

  if (!leave) {
    return (
      <div className='p-6'>
        <PageHeader title={t('Leave Details')} />
        <p className='mt-4'>{t('No_leave_selected')}</p>
        <div className='mt-4'></div>
      </div>
    )
  }

  const data = [leave]

  return (
    <div>
      <PageHeader title={t('Leave Details')} />
      <CustomTable data={data} columns={columns} rows={1} />
    </div>
  )
}
